import React from 'react'
import { Modal } from 'react-bootstrap'

const SmsMmsPopup = ({show, handleClose}:any) => {
return (
<Modal id='kt_modal_create_app' tabIndex={1} aria-hidden='true' dialogClassName='modal-dialog-centered mw-650px'
    className='vh-100 credit-modal sms-modal' show={show} onHide={handleClose}>
    <div className=''>
        <div className="modal-header">
            <h5 className="modal-title">SMS vs MMS</h5>
            <button type="button" className="close" onClick={handleClose} aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div className="modal-body">
            <div className='table-responsive'>
            <table width={"100%"}>
                <thead>
                    <tr>
                        <th></th>
                        <th>MMS</th>
                        <th>SMS</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Capabilities</td>
                        <td>Send written text, video, GIF and photos</td>
                        <td>Send written text only</td>
                    </tr>
                    <tr>
                        <td>Character count</td>
                        <td>1,000 per message</td>
                        <td>160 per message</td>
                    </tr>
                    <tr>
                        <td>Media</td>
                        <td>Image  - 50kb
                            Video - 50kb
                            GIF  - 50kb
                        </td>
                        <td>N/A</td>
                    </tr>
                    <tr>
                        <td>Affordability</td>
                        <td>More expensive</td>
                        <td>Cheaper</td>
                    </tr>
                    <tr>
                        <td>Engagement</td>
                        <td>High</td>
                        <td>Low</td>
                    </tr>
                </tbody>
            </table>
            </div>
        </div>

    </div>
</Modal>
)
}

export default SmsMmsPopup